<template>
  <v-dialog v-model="dialogComputed" :max-width="width">
    <v-card>
      <v-card-title :class="getTitleClass">
        {{ title }}
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="closeModal"
          class="ml-auto"
        ></v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="buttonColor" @click="closeModal" variant="text">
          {{ buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Aviso'
  },
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'info',
    validator: (value) =>
      ['success', 'error', 'warning', 'info'].includes(value)
  },
  width: {
    type: [Number, String],
    default: 500
  },
  buttonText: {
    type: String,
    default: 'Aceptar'
  }
})

const emit = defineEmits(['update:modelValue'])

// Computed properties
const dialogComputed = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const getTitleClass = computed(() => {
  const baseClass = 'text-white'
  const colorMap = {
    success: 'bg-success',
    error: 'bg-error',
    warning: 'bg-warning',
    info: 'bg-info'
  }
  return `${baseClass} ${colorMap[props.type]}`
})

const buttonColor = computed(() => props.type)

// Methods
const closeModal = () => {
  emit('update:modelValue', false)
}
</script>
